import { EmailField } from '@/domain/mitarbeiter/features/anlageassistent/components/EmailField';
import { FieldBase } from '@/domain/mitarbeiter/features/anlageassistent/components/form/fieldComponents/FieldBase';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { formatPhoneNumber } from '@/domain/mitarbeiter/features/anlageassistent/utils/formatPhoneNumber';
import { Body, Heading, Input } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

export function Kontakt() {
  const { ctx } = useAnlageassistentContext();
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-3">
        <Heading>{ctx.getCurrentSubStep()?.title}</Heading>
        <Body>
          {t('domain.mitarbeiter.create.steps.person.kontakt.description')}
        </Body>
      </div>

      <div className="col-span-2 grid md:grid-cols-2 items-start gap-4">
        <EmailField />
        <div className="flex items-end gap-2">
          <form.AppField name="person.kontakt.mobilnummer">
            {(field) => {
              const isInvalid = !field.state.meta.isValid;
              return (
                <FieldBase
                  label={t(
                    'domain.mitarbeiter.create.steps.person.kontakt.form.phone.label',
                  )}>
                  <Input
                    id={field.name}
                    name={field.name}
                    type="tel"
                    inputMode="tel"
                    value={field.state.value || ''}
                    onChange={(e) =>
                      field.handleChange(
                        e.target.value === '' ? null : e.target.value,
                      )
                    }
                    onBlur={() => {
                      const value = field.state.value;
                      if (value) {
                        field.setValue(formatPhoneNumber(value));
                      }
                      field.handleBlur();
                    }}
                    aria-invalid={isInvalid}
                  />
                </FieldBase>
              );
            }}
          </form.AppField>
        </div>
      </div>
    </div>
  );
}
